import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { PerformanceMenu } from '@v2/pages/machines/common/components/Header/components';
import ColorWrapper, { WithColor } from '@styles/colors';
import { injectConditionalObject, isPhone } from '@helpers';
import { ContainerStyle } from '@interfaces/base';
import { useManagePerformanceHeader } from '@v2/pages/performance/common/useManagePerformanceHeader';
import { scale } from '@components/frame';
import { HEADER_MOBILE_GAP_BETWEEN_LEVELS, SCREEN_PADDING_VERTICAL } from '@v2/pages/common/constants/base.constants';

interface PerformanceScreensHeaderProps extends WithColor, ContainerStyle {}

const PerformanceScreensHeader: FC<PerformanceScreensHeaderProps> = ({ C, containerStyle }) => {
  const { handleNavigate, checkIsSelected } = useManagePerformanceHeader();

  return (
    <View style={{ gap: scale(HEADER_MOBILE_GAP_BETWEEN_LEVELS), marginBottom: scale(SCREEN_PADDING_VERTICAL) }}>
      <PerformanceMenu
        rowStyles={[
          {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            borderTopColor: C('Hairline/Light/No trans'),
            borderTopWidth: isPhone ? StyleSheet.hairlineWidth : 0,
            paddingTop: scale(HEADER_MOBILE_GAP_BETWEEN_LEVELS * 2),
          },
          ,
        ]}
        checkIsSelected={checkIsSelected}
        onPress={handleNavigate}
      />
    </View>
  );
};

export default ColorWrapper(PerformanceScreensHeader);
